import { UserRolesCreateForm } from "Settings/User/Components/Form/UserRolesCreateForm";
import { UserRolesDefault } from "Settings/User/Components/UserRoles/UserRolesDefault";
import { UserRolesEdit } from "Settings/User/Components/UserRoles/UserRolesEdit";
import { UserRolesList } from "Settings/User/Components/UserRoles/UserRolesList";
import type { UserRolesContentType } from "Settings/User/Pages/UserRoles/UserRoles";
import { BlankCard } from "Shared/Components/Cards/BlankCard";
import { Box, Divider, Stack, type Theme, useMediaQuery } from "@mui/material";
import type { FC } from "react";

const UserRolesComponents = {
	add: UserRolesCreateForm,
	edit: UserRolesEdit,
	default: UserRolesDefault,
};

type Props = {
	currentContent: UserRolesContentType;
};

export const UserRoleCard: FC<Props> = ({ currentContent }) => {
	const isSmallScreen = useMediaQuery((theme: Theme) =>
		theme.breakpoints.down("sm"),
	);

	const FormComponent = UserRolesComponents[currentContent];

	return (
		<BlankCard>
			<Stack flexDirection={{ xs: "column", sm: "row" }}>
				<Box width={{ sm: "270px" }} flexShrink={0} p={3}>
					<UserRolesList />
				</Box>
				<Divider
					orientation={isSmallScreen ? "horizontal" : "vertical"}
					flexItem
				/>
				<Box width={{ xs: "100%", sm: "calc(100% - 270px)" }} p={3}>
					<FormComponent />
				</Box>
			</Stack>
		</BlankCard>
	);
};
